module.exports = __webpack_public_path__ + "static/media/alcov.b72b6dfa.png";